<template>
    <v-card :loading="loading">
        <v-card-title>
            <span class="title-modal">Novo Veículo</span>
        </v-card-title>
        <v-card-text>
            <v-form ref="formNewVehicle">
                <v-row>
                    <v-col cols="12">
                        <v-text-field
                                :rules="plateValidation"
                                @keyup="plate = plate.toUpperCase()"
                                v-model="plate"
                                v-mask="plateMask"
                                required
                                label="Placa">
                        </v-text-field>
                        <v-switch
                            @click="$refs.formNewVehicle.validate()"
                            label="Placa estrangeira"
                            v-model="is_foreigner"
                        />
                    </v-col>
                </v-row>
                <v-col v-if="errors.searchPlate !== null" cols="12" class="p-0">
                    <v-alert type="error" color="#e72c1f">
                        {{errors.searchPlate}}
                    </v-alert>
                </v-col>
                <v-col v-if="errors.newVehicle !== null" cols="12" class="p-0">
                    <v-alert type="error" color="#e72c1f">
                        {{errors.newVehicle}}
                    </v-alert>
                </v-col>
            </v-form>
        </v-card-text>
        <v-card-actions>
            <v-col class="flex-grow-1 text-right">
                <v-btn class="btn-cancel m-0" @click.prevent="close()">Cancelar</v-btn>
                <v-btn class="btn-confirm" @click="associateVehicle()">Cadastrar</v-btn>
            </v-col>
        </v-card-actions>
        <v-snackbar
                v-model="message_success"
                :color="'success'"
                :multi-line="true"
                :right="true"
                :timeout="2000"
                :top="true"
                class="snackbar-success"
        >
            <span><i class="fas fa-check mr-2"></i> Veículo cadastrado com sucesso!</span>
        </v-snackbar>
    </v-card>
</template>

<script>
    export default {
        name: "NewVehicle",
        data:function () {
            return{
                loading:false,
                message_success:false,
                errors:{
                  searchPlate:null,
                  newVehicle:null
                },
                vehicle_id:null,
                plate:'',
                types:[],
                type:{},
                is_foreigner: false,
            }
        },
        mounted() {
            this.loading = true;
        },
        methods:{
            associateVehicle: function(){
                this.loading = true;
                axios.post('/api/vehicle/plate/wallet/associate',{plate: this.plate })
                    .then(() => {
                      this.message_success = true;
                      setTimeout(() => {
                        this.close();
                      }, 1000);
                    }).catch(error => {
                      this.errors.newVehicle =
                          error || 'Ocorreu um erro. Tente novamente.';
                    }).finally(() => {
                      this.loading = false;
                    });
            },
            close:function () {
                this.$emit('close',false);
            }
        },
        computed:{
            plateValidation: function () {
                return [
                  value => (value || '').length > 0 || 'A placa é obrigatória',
                  value => {
                    const regex = this.is_foreigner ?
                        '[A-Z0-9]{3}'
                        : '[A-Z]{3}[0-9]{4}|[A-Z]{3}[0-9]{1}[A-Z]{1}[0-9]{2}';
                    return value.match(regex) || 'Digite uma placa de veículo válida'
                  },
                ]
            },
            plateMask: function () {
                return this.is_foreigner ? 'XXXXXXXX' : 'XXXXXXX';
            },
        }
    }
</script>

<style scoped>
    @media only screen and (max-width: 500px){
        .btn-confirm, .btn-cancel{
            width: 100%;
            margin: 5px 0 !important;
            padding: 0;
        }
    }
</style>
